import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';
import React, { RefObject } from 'react';

import styles from './DropdownMenu.module.scss';

export interface DropdownMenuProps {
  triggerNode: React.ReactNode;
  children?: React.ReactNode;
  onOpenChange?: (open: boolean) => void;
  open?: boolean;
  triggerProps?: Partial<RadixDropdown.DropdownMenuTriggerProps>;
  contentProps?: Partial<RadixDropdown.DropdownMenuContentProps>;
  contentRef?: RefObject<HTMLDivElement | null>;
  align?: 'start' | 'center' | 'end';
  className?: string;
  modal?: boolean;
}

export const DropdownMenu = ({
  triggerNode,
  children,
  onOpenChange,
  open,
  contentProps,
  triggerProps,
  contentRef,
  align = 'start',
  className,
  modal = true,
}: DropdownMenuProps) => {
  return (
    <RadixDropdown.Root
      modal={modal}
      onOpenChange={onOpenChange}
      {...(open !== undefined ? { open: open } : {})}
    >
      <RadixDropdown.Trigger asChild {...triggerProps}>
        {triggerNode}
      </RadixDropdown.Trigger>
      <RadixDropdown.Portal>
        <RadixDropdown.Content
          ref={contentRef}
          className={clsx(styles.dropdownContent, className)}
          align={align}
          sideOffset={5}
          {...contentProps}
        >
          {children}
        </RadixDropdown.Content>
      </RadixDropdown.Portal>
    </RadixDropdown.Root>
  );
};
